// env.config.js
// This file is required by @edx/frontend-platform
// It can export either an object or a function that returns an object
// The configuration will be merged into the application config

export default {};
